module.exports = __webpack_public_path__ + "img/xaas-riasat-jomhoori.71d031e.svg";